<p-fieldset class="title-legend" legend="{{titulo}}" [style]="{'margin-bottom': '.5rem'}">
    <div class="formgrid grid m-0 p-fluid">
        <div class="field field-mg col-12">
            <p-autoComplete [(ngModel)]="olho.olhoLente" [lazy]="true" [delay]="1000" [suggestions]="produtosLentesFiltrado" (ngModelChange)="changeProdutoEmit($event)" (completeMethod)="filterAutoComplete($event)" field="descricao" [style]="{'min-width':'100%'}" [styleClass]="'p-inputtext-sm w-full'" [placeholder]="'Digite para pesquisar...'">
                <ng-template let-produto pTemplate="item">
                    <div class="formgrid grid m-0 p-fluid">
                        <div class="field col-12 lg:col-3 text-sm">
                            <span class="titulo">Código</span>
                            <span>{{produto.cod_produto}}</span>
                        </div>
                        <div class="field col text-sm card-text">
                            <span class="titulo">Descrição</span>
                            <span>{{produto.descricao}}</span>
                        </div>
                    </div>
                    <div class="formgrid grid m-0 p-fluid">
                        <div class="field col-12 lg:col-3 text-sm">
                            <span class="titulo">Vlr Venda</span>
                            <span>{{produto.vlr_venda_tratado | currency: 'BRL' }}</span>
                        </div>
                        <div class="field col text-sm">
                            <span class="titulo">Perc Desconto</span>
                            <span>{{produto.desc_acresc_porcentagem | number: '1.1-2' }} %</span>
                        </div>
                        <div class="field col text-sm">
                            <span class="titulo">Vlr Liquido</span>
                            <span>{{produto.vlr_liquido_produto | currency: 'BRL' }}</span>
                        </div>
                    </div>
                </ng-template>
            </p-autoComplete>
        </div>
    </div>

    <div class="flex-cards">
        <p-fieldset class="base-legend" legend="Longe">
            
            <div class="p-fluid formgrid m-0 grid">
                
                <div class="flex-auto field col-6 lg:col-1">
                    <label>Esférico</label>
                    <input type="text" (input)="formatarInput($event.target, 'esfericoLonge')" [(ngModel)]="olho.olhoLongeEsferico" class="inputP" [maxlength]="maxlength">
                </div>
                <div class="flex-auto field col-6 lg:col-1">
                    <label>Cilíndrico</label>
                    <input type="text" (input)="formatarInput($event.target, 'cilindricoLonge')" [(ngModel)]="olho.olhoLongeCilindrico" class="inputP" [maxlength]="maxlength">
                    
                </div>
                <div class="flex-auto field col-6 lg:col-1">
                    <label>Eixo</label>
                    <input type="number" (keyup)="eixoMinMax($event)"  (onBlur)="blurLonge()" [(ngModel)]="olho.olhoLongeEixo" min="0" max="180" class="inputP">
                   
                </div>
                <div class="flex-auto field col-6 lg:col-1">
                    <label>DNP</label>
                    <input type="text" (input)="formatarInput($event.target, 'dnpLonge')" (onBlur)="blurLonge()" (ngModelChange)="changeDNPLonge($event)" [(ngModel)]="olho.olhoLongeDNP"  class="inputP"  [maxlength]="maxlength"/>
                    
                </div>
            </div>
        </p-fieldset>

        <p-fieldset class="base-legend" legend="Adição">
            <div class="p-fluid formgrid m-0 grid">
                <div class="flex-auto field col-12 lg:col-1">
                    <label>Adição</label>
                    
                    <input type="text" (input)="formatarInput($event.target, 'adicao')" (blur)="blurLonge()" [(ngModel)]="olho.olhoAdicao" class="inputP"/>
                </div>
            </div>
        </p-fieldset> 

        <p-fieldset class="base-legend" legend="Perto">
            
            <div class="p-fluid formgrid m-0 grid">
                <div class="flex-auto field col-6 md:col-3 lg:col-1">
                    <label>Esférico</label>
                    <input type="text" (input)="formatarInput($event.target, 'esfericoPerto')" [(ngModel)]="olho.olhoPertoEsferico" class="inputP" [maxlength]="maxlength">
                </div>
                <div class="flex-auto field col-6 md:col-3 lg:col-1">
                    <label>Cilíndrico</label>
                    <input type="text" (input)="formatarInput($event.target, 'cilindricoPerto')" [(ngModel)]="olho.olhoPertoCilindrico" class="inputP" [maxlength]="maxlength">
                    
                </div>
                <div class="flex-auto field col-6 md:col-3 lg:col-1">
                    <label>Eixo</label>
                    <input type="number" (keyup)="eixoMinMax($event)" [(ngModel)]="olho.olhoPertoEixo" min="0" max="180" class="inputP">
                   
                </div>
                <div class="flex-auto field col-6 md:col-3 lg:col-1">
                    <label>DNP</label>
                    <input type="text" (input)="formatarInput($event.target, 'dnpPerto')" (onBlur)="blurLonge()" (ngModelChange)="changeDNPLonge($event)" [(ngModel)]="olho.olhoPertoDNP"  class="inputP"  [maxlength]="maxlength"/>
                   
                </div>
            </div>
        </p-fieldset>
    </div>

    <div class="grid-prisma">
        
        <p-fieldset class="base-legend" legend="Alt da pupila">
            <label>Altura da pupila</label>
            <input type="text" (input)="formatarInput($event.target, 'altura_pupila')" [(ngModel)]="olho.olhoAlturaPupila"  class="inputP">
        </p-fieldset>
            
        <p-fieldset class="base-legend" legend="Prisma horizontal">
            <div class="inputs-prisma">
                <div class="prisma-valor">
                    <label>Valor</label>
                    <input type="text" (input)="formatarInput($event.target, 'prisma_hor_valor')" [(ngModel)]="olho.olhoPrismaHorizontalValor" class="inputP">
                </div>
                <div class="prisma-base">
                    <label>Base</label>
                    <p-dropdown class="teste0102" [options]="primaBasesHorizontal" [(ngModel)]="olho.olhoPrismaHorizontalBase" placeholder="Selecione" optionLabel="nome" [showClear]="true"  [style]="{'width':'100%'}" [styleClass]="'text-sm'"></p-dropdown>
                </div>
            </div>
        </p-fieldset>

        <p-fieldset class="base-legend" legend="Prisma vertical">
            <div class="inputs-prisma">
                <div class="prisma-valor">
                    <label>Valor</label>
                    <input type="text" (input)="formatarInput($event.target, 'prisma_vert_valor')" [(ngModel)]="olho.olhoPrismaVerticalValor" class="inputP">
                </div>
                <div class="prisma-base">
                    <label>Base</label>
                    <p-dropdown class="teste0102" [options]="primaBasesVertical" [(ngModel)]="olho.olhoPrismaVerticalBase" placeholder="Selecione" optionLabel="nome" [showClear]="true"  [style]="{'width':'100%'}" [styleClass]="'text-sm'"></p-dropdown>
                </div>
            </div>
        </p-fieldset>
    </div>
</p-fieldset>